import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/rmplus/',
  name: 'rmplus',
  meta: {
    auth: true
  },
  redirect: {
    name: 'rmplus/account'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'index',
      name: `${pre}index`,
      component: _import('rmplus/index'),
      meta: {
        title: '概览'
      }
    }, {
      path: 'account',
      name: `${pre}account`,
      // component: _import('rmplus/account'),
      component: _import('media/tree/index'),
      meta: {
        title: '媒体矩阵'
      }
    },

    {
      path: 'account/add',
      name: `${pre}account-add`,
      component: _import('rmplus/account/add'),
      meta: {
        title: '添加媒体'
      }
    }, {
      path: 'account/edit',
      name: `${pre}account-edit`,
      component: _import('rmplus/account/edit'),
      meta: {
        title: '编辑媒体'
      }
    },
    {
      path: 'user1',
      name: `${pre}user1`,
      component: _import('rmplus/user/index1'),
      meta: {
        title: '公众号用户'
      }
    },
    {
      path: 'user',
      name: `${pre}user`,
      component: _import('rmplus/user'),
      meta: {
        title: '公众号用户'
      }
    }, {
      path: 'material',
      name: `${pre}material`,
      component: _import('rmplus/material'),
      meta: {
        title: '素材中心'
      }
    },
    {
      path: 'material/add',
      name: `${pre}material-add`,
      component: _import('rmplus/material/add2'),
      meta: {
        title: '添加素材'
      }
    }, {
      path: 'material/edit',
      name: `${pre}material-edit`,
      component: _import('rmplus/material/add2'),
      meta: {
        title: '编辑素材'
      }
    },
    {
      path: 'analysis',
      name: `${pre}analysis`,
      component: _import('rmplus/analysis'),
      meta: {
        title: '数据分析'
      }
    },
    {
      path: 'rank/wechat',
      name: `${pre}rank-wechat`,
      meta: {
        title: '微信榜单'
      },
      component: _import('rmplus/rank/wechat')
    },
    {
      path: 'weibo/update',
      name: `${pre}weibo-update`,
      meta: {
        title: '微博发布'
      },
      component: _import('rmplus/weibo/edit')
    },
    {
      path: 'douyin/upload',
      name: `${pre}douyin-upload`,
      meta: {
        title: '抖音发布'
      },
      component: _import('rmplus/douyin/upload')
    },

    {
      path: 'bigScreen/bigScreen',
      name: `${pre}bigScreen/bigScreen`,
      meta: {
        title: '大屏'
      },
      component: _import('rmplus/bigScreen/bigScreen')
    },
    {
      path: 'bigScreen/vertical',
      name: `${pre}bigScreen/vertical`,
      meta: {
        title: '大屏（竖版）'
      },
      component: _import('rmplus/bigScreen/vertical')
    },
    {
      path: 'bigScreen/admin',
      name: `${pre}bigScreen/admin`,
      meta: {
        title: '大屏管理后台'
      },
      component: _import('rmplus/bigScreen/admin')
    },
    {
      path: 'news',
      name: `${pre}news`,
      component: _import('rmplus/news'),
      meta: {
        title: '发文管理'
      }
    },
    // 头条录入页面
    {
      path: 'toutiao/edit',
      name: `${pre}toutiao-edit`,
      meta: {
        title: '头条录入页面'
      },
      component: () => import('@/views/rmplus/toutiao/add/index')
    }])('rmplus/')
}
